import { Badge, Button, Icon } from '@ps/isp-web-component-library';
import { BetBuilderBadge } from '@ps/isp-web-component-library/icons/BetBuilderBadge';
import { InPlay } from '@ps/isp-web-component-library/icons/InPlay';
import { Link, Translation } from '@ps/web-shared-components';
import React from 'react';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import FormattedDateTime from '@swf/sports/components/FormattedDateTime/FormattedDateTime';

import type { EventDynamicBanner, ImageFetchProps } from '../../../../model/types';
import BannerImage from '../../../BannerImage/BannerImage';

import {
  TXTWCL_Bet_Builder,
  TXTWCL_Build_your_bet_here,
  TXTWCL_In_Play
} from './BetBuilder.messages.json';
import styles from './BetBuilder.scss';

const BetBuilderDynamicBanner: React.FC<EventDynamicBanner & ImageFetchProps> = ({
  image,
  event: { eventName, eventId, eventSlug, eventStartTime },
  eventType: { eventTypeId, eventTypeSlug },
  competition: { competitionId, competitionName, competitionSlug },
  slug,
  priority
}) => {
  const { formatMessage } = useRegulatoryIntl();
  // it would require bff changes to return the isInPlay prop for the event
  const eventStartTimestamp = new Date(eventStartTime).getTime();
  const isEventInPlay = Date.now() >= eventStartTimestamp;

  return (
    <div className={styles.container}>
      <BannerImage image={image} priority={priority} />
      <div className={styles.inner}>
        <div className={styles.heading}>
          <div className={styles.iconContainer}>
            <Badge
              icon={BetBuilderBadge}
              iconLabel={formatMessage(TXTWCL_Bet_Builder)}
              text={formatMessage(TXTWCL_Bet_Builder)}
              className={styles.icon}
              size="base"
            />
          </div>
        </div>
        <div className={styles.time}>
          <Icon icon={InPlay} size="sm" />
          {isEventInPlay ? (
            <Translation {...TXTWCL_In_Play} />
          ) : (
            <FormattedDateTime date={eventStartTime} format="short" />
          )}
        </div>
        <div className={styles.eventName}>{eventName}</div>
        <div className={styles.competitionWithDate}>
          {competitionName}
          {!isEventInPlay && (
            <>
              {', '}
              <FormattedDateTime date={eventStartTime} format="short" hideTime />
            </>
          )}
        </div>
        <div className={styles.linkContainer}>
          <Button isFullWidth variant="primary">
            <Link
              className={styles.link}
              alias="sportsEvent"
              values={{
                competitionId,
                competitionSlug,
                eventId,
                eventSlug,
                eventTypeId,
                eventTypeSlug
              }}
              hash={slug}
            >
              <Translation {...TXTWCL_Build_your_bet_here} />
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BetBuilderDynamicBanner;
